import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAboutUsFourSecData, getAboutUsMainData, getAboutUsSecondSecData, getAboutUsSixSecData, getAboutUsThirdSecData } from '../../../Redux/action/MasterAction';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import parse from 'html-react-parser'
import AOS from "aos";
import "aos/dist/aos.css";
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import OwlCarousel from 'react-owl-carousel';
import FeedbackForm from '../../FeedbackForm/FeedbackForm';
import SkeletonLoaderAboutUs from '../../../Common/skeleton/AboutUs/SkeletonLoaderAboutUs';
const host = process.env.REACT_APP_API_SERVER
const AboutUs = () => {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAboutUsMainData());
        dispatch(getAboutUsSecondSecData());
        dispatch(getAboutUsThirdSecData());
        dispatch(getAboutUsFourSecData());
        dispatch(getAboutUsSixSecData());
    }, [])

    const {
        loadingAboutUsMainDataListApi,
        AboutUsMainDataListApiData,
        AboutUsMainDataListApiError,

        loadingAboutUsSecondSecDataListApi,
        AboutUsSecondSecDataListApiData,
        AboutUsSecondSecDataListApiError,

        loadingAboutUsThirdSecDataListApi,
        AboutUsThirdSecDataListApiData,
        AboutUsThirdSecDataListApiError,

        loadingAboutUsFourSecDataListApi,
        AboutUsFourSecDataListApiData,
        AboutUsFourSecDataListApiError,

        loadingAboutUsSixSecDataListApi,
        AboutUsSixSecDataListApiData,
        AboutUsSixSecDataListApiError,
    } = useSelector(state => state?.MasterReducer);

    const options = {
        loop: AboutUsThirdSecDataListApiData?.length > 4,
        margin: 10,
        nav: true,
        dots: false,
        autoplay: true, // Enable autoplay
        autoplayTimeout: 2000, // Set the time (in milliseconds) for each slide
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 4
            }
        }
    }

    const options1 = {
        loop: AboutUsFourSecDataListApiData?.length > 5,
        margin: 2,
        nav: true,
        dots: false,
        autoplay: true, // Enable autoplay
        autoplayTimeout: 2000, // Set the time (in milliseconds) for each slide
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        }
    }

    useEffect(() => {
        AOS.init({
           
            easing: "fade-up",
        });
    }, []);

    return (
        <>
         <Header />
            <FeedbackForm />
       {loadingAboutUsMainDataListApi?
       
       <SkeletonLoaderAboutUs/>
     
       :
         <div className='about-us'>
           
            <section>


                <img style={{ marginTop: '80px' }}
                    src={`${host}${AboutUsMainDataListApiData?.banner}`}
                />




            </section>
            <section className="here-to-help my-5">
                <div className="container">

                    <div className="container container--large" >
                        <div>

                            <h2 className="image-content__heading ">
                                <strong>{AboutUsMainDataListApiData?.section1_title}</strong>
                            </h2>
                            {AboutUsMainDataListApiData?.section1_description ? parse(AboutUsMainDataListApiData?.section1_description) : ''}

                        </div>
                        <div className="heading">
                            <h2 className="image-content__heading ">
                                <strong>{AboutUsMainDataListApiData?.section2_title}</strong>
                            </h2>
                        </div>
                        <div className="image-content">
                            <div className="image-content">
                                <div className="image-content">
                                    {AboutUsSecondSecDataListApiData?.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`${index % 2 === 0 ? "image-content__row-odd" : "image-content__row"}`}
                                            data-aos="fade-up"
                                        >
                                            {/* For even index: Image first, Text second */}
                                            {index % 2 !== 0 ? (
                                                <>
                                                    <div className="image-content__column image-content__image">
                                                        <img
                                                        style={{maxWidth:'16rem'}}
                                                            src={`${host}${item.image}`}
                                                            title={item.title || "Image"}
                                                            alt={item.alt || "Image description"}
                                                            className="image--lazy"
                                                        />
                                                    </div>
                                                    <div className="image-content__column image-content__text mx-2">
                                                        <div
                                                            className="text-block text-block--heading"
                                                            data-component="text_block"
                                                        >
                                                            <div className="container container--medium dark">
                                                                <h3>{item.title}</h3>
                                                                <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                /* For odd index: Text first, Image second */
                                                <>
                                                    <div className="image-content__column image-content__image">
                                                        <img
                                                         style={{maxWidth:'16rem'}}
                                                            src={`${host}${item.image}`}
                                                            title={item.title || "Image"}
                                                            alt={item.alt || "Image description"}
                                                            className="image--lazy"
                                                        />
                                                    </div>
                                                    <div className="image-content__column image-content__text mx-2">
                                                        <div
                                                            className="text-block text-block--heading"
                                                            data-component="text_block"
                                                        >
                                                            <div className="container container--medium dark">
                                                                <h3>{item.title}</h3>
                                                                <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>


                            </div>

                        </div>

                        <div
                            className="section-header text-center aos aos-init aos-animate"
                            data-aos="fade-up"
                        >
                            <h2>
                                <strong>{AboutUsMainDataListApiData?.section3_title}</strong>
                            </h2>
                            <p className="sub-title">
                                {AboutUsMainDataListApiData?.section3_description}
                            </p>

                        </div>
                    </div>
                </div>
            </section>
            <section className="why-tutor-with-us my-5" >
                <div className="container">


                    <OwlCarousel className='owl-theme section ' loop margin={20} autoplay {...options}>

 
                        {AboutUsThirdSecDataListApiData?.map((data, index) => (
                            <div style={{ position: 'relative', padding: '30px 0 0 0' }}>
                                <div key={index} style={{ padding: '10px' }}>
                                    <Card className="border-0" style={{ position: 'normal' }}>
                                        <Card.Img
                                            className="about-us-card-img"
                                            variant="top"
                                            src={`${host}${data?.image}`}
                                        />
                                        <Card.Body className="about-us-card" style={{ height: '12rem' }}>
                                            <Card.Text className="py-5" style={{ textAlign: 'center' }}>
                                                {data?.description ? parse(data?.description) : ''}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        ))}

                    </OwlCarousel>


                </div>
            </section>

            <section className='bg-light my-5'>
                <div className="container container--large" data-aos="fade-up">
                    <div className="container">
                        <div className="row py-5">
                            <div className="col-md-2 align-content-center" style={{ width: '19%' }}>
                                <img src={`${host}${AboutUsMainDataListApiData?.section4_main_img}`} alt="" srcset="" />
                            </div>
                            <div className='col-md-9'>
                                <div
                                    className="section-headeraos aos-init aos-animate"
                                    data-aos="fade-up"
                                >
                                    <h3 style={{ color: '#29abe2'}}>
                                        <strong> {AboutUsMainDataListApiData?.section4_title}</strong>
                                    </h3>
                                    <p className="sub-title">
                                        {AboutUsMainDataListApiData?.section3_description}
                                    </p>

                                </div>
                                <OwlCarousel className='owl-theme section ' loop margin={2} autoplay {...options1}>

                                    {AboutUsFourSecDataListApiData?.map((data) => (
                                        <Card className='mx-2 cust-card-about'>
                                            <Card.Body>
                                                <Card.Text className='text-dark'>
                                                    {data?.title}
                                                </Card.Text>
                                            </Card.Body>
                                            <Card.Img className='p-2 cust-card-img-about' variant="bottom" src={`${host}${data?.image}`} />
                                        </Card>
                                    ))}


                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="why-tutor-with-us my-5" data-aos="fade-up">
                <div className="container">
                    <div
                        className="section-headeraos text-center aos-init aos-animate"
                        data-aos="fade-up"
                    >
                        <h2>
                            <strong>{AboutUsMainDataListApiData?.section5_title}</strong>
                        </h2>
                        <p className="sub-title">
                            {AboutUsMainDataListApiData?.section5_description}
                        </p>

                    </div>

                    <CardGroup className='gap-4'>
                        <Card className='breaking-barrier-card'>

                            <Card.Body className='d-flex align-content-center flex-wrap text-align-center'>

                                <Card.Text style={{ fontWeight: 'bold', borderRadius: '10px', textAlign: 'center' }}>
                                    {AboutUsMainDataListApiData?.section5_tile1}
                                </Card.Text>
                            </Card.Body>

                        </Card>
                        <Card className='breaking-barrier-card'>

                            <Card.Body className='d-flex align-content-center flex-wrap'>

                                <Card.Text className='breakingtext' style={{ fontWeight: 'bold' }}>
                                    {AboutUsMainDataListApiData?.section5_tile2}
                                </Card.Text>
                            </Card.Body>

                        </Card>
                        <Card className='breaking-barrier-card'>

                            <Card.Body className='d-flex align-content-center flex-wrap'>

                                <Card.Text style={{ fontWeight: 'bold' }}>
                                    {AboutUsMainDataListApiData?.section5_tile3}
                                </Card.Text>
                            </Card.Body>

                        </Card>

                    </CardGroup>


                </div>
            </section>

            <section className='my-5'>
                <div className="container">
                    <div className="container container--large" data-aos="fade-up">
                        <div className="image-content">
                            <div className="image-content">
                                <div className="image-content">
                                    {AboutUsSixSecDataListApiData?.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`${index % 2 === 0 ? "image-content__row-odd" : "image-content__row"}`}
                                            data-aos="fade-up"
                                        >
                                            {/* For even index: Image first, Text second */}
                                            {index % 2 !== 0 ? (
                                                <>
                                                    <div className="image-content__column image-content__image">
                                                        <img
                                                         style={{maxWidth:'16rem'}}
                                                            src={`${host}${item.image}`}
                                                            title={item.title || "Image"}
                                                            alt={item.alt || "Image description"}
                                                            className="image--lazy"
                                                        />
                                                    </div>
                                                    <div className="image-content__column image-content__text">
                                                        <div
                                                            className="text-block text-block--heading"
                                                            data-component="text_block"
                                                        >
                                                            <div className="container container--medium dark">
                                                                <h3>{item.title}</h3>
                                                                <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                /* For odd index: Text first, Image second */
                                                <>
                                                    <div className="image-content__column image-content__image">
                                                        <img
                                                         style={{maxWidth:'16rem'}}
                                                            src={`${host}${item.image}`}
                                                            title={item.title || "Image"}
                                                            alt={item.alt || "Image description"}
                                                            className="image--lazy"
                                                        />
                                                    </div>
                                                    <div className="image-content__column image-content__text">
                                                        <div
                                                            className="text-block text-block--heading"
                                                            data-component="text_block"
                                                        >
                                                            <div className="container container--medium dark">
                                                                <h3>{item.title}</h3>
                                                                <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
            </section>



            <Footer />
        </div>}
        </>
    )
}

export default AboutUs